import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { showPlatform } from '@/util';
@Component({
  components: {},
  mixins: [style],
})
export default class Member extends Vue {
  @Prop({ default: () => {} })
    value: DisplayMemberData;

  @Prop({ default: 1 })
    themeCode: number;

  brandMore = false;

  get brandConfig() {
    return this?.value?.desc?.brandGroupConfig;
  }

  get isShowBrandMore() {
    return this.brandListCheckList.length > this.brandConfig.defalutShowNumber;
  }

  get brandListCheckList() {
    return this.brandList.filter(i => i.check);
  }

  brandList = [];
  mounted() {
    const list = ['really', 'test001', 'demoenv', 'devtest2'];
    showPlatform(list) && this.getBrandList();
  }

  getBrandList() {
    IPSService.crmSystemBrandGroup().then((resp) => {
      console.log(resp);
      if (resp?.items) {
        const items: any[] = (resp.items || []).filter(i => i.status);
        // 过滤掉不在系统中的品牌组
        const listFilter = this.brandConfig.brandGroupList.filter((i) => {
          return items.map(v => v.code).includes(i);
        });

        // 已选的品牌需在前面

        const newItems = items
          .map((i: any) => {
            i.check = listFilter.includes(i.code);
            return i;
          })
          .filter((i) => {
            return !listFilter.includes(i.code);
          });

        newItems.unshift(
          ...listFilter
            .map((i) => {
              return items.find(v => v.code === i);
            })
            .map((v) => {
              v.check = true;
              return v;
            }),
        );

        this.$store.commit('updateBrandList', newItems);
        this.brandList = newItems;
      }
    });
  }

  // 区块背景色
  get blockBackground() {
    return this.themeCode > 3 ? '#181818' : '#ffffff';
  }

  render(h) {
    return (
      <div class="width-100 r-mx-18 member-container">
        {!this.value.desc.isPre ? (
          <div class="member box-shadow relative-position" style={`background: ${this.blockBackground};z-index:10`}>
            <div class="level">
              <p class="title-text">等级</p>
              <p class="item-value">XX</p>
            </div>
            <div class="point">
              <p class="title-text">积分</p>
              <p class="item-value">XXX</p>
            </div>
            <div class="coupon">
              <p class="title-text">优惠券</p>
              <p class="item-value">X</p>
            </div>
          </div>
        ) : (
          <img class="member-img" src={`${this.value.desc.enterPic}?imageView2/1/w/750/h/300`} />
        )}
        {this.brandConfig.isOpen && this.brandListCheckList.length ? (
          <div class="bands text-grey-8 text-caption ">
            <div class="bg-white  box-shadow bands-wrap q-px-sm">
              <p class="no-margin title ">各品牌{this.brandConfig.showType === 1 ? '历史累计消费金额' : '近一年累计消费金额'}（元）</p>
              <ul class="no-padding no-margin">
                {this.brandListCheckList
                  .filter((_, index) => (this.brandMore ? true : index < this.brandConfig.defalutShowNumber))
                  .map((i) => {
                    return (
                      <li class="flex justify-between text-black ">
                        <span class="band font-bold text-overflow flex-1">{i.name}</span>
                        <span class="money flex-shrink">¥0.00</span>
                      </li>
                    );
                  })}
              </ul>
              {this.isShowBrandMore ? (
                <p class="no-margin flex justify-center cursor-pointer" on-click={() => (this.brandMore = !this.brandMore)}>
                  <i aria-hidden="true" class={[' r-ml-4', this.brandMore ? 'el-icon-caret-top' : 'el-icon-caret-bottom']} style="font-size: 16px;"></i>
                  {this.brandMore ? '收起' : '更多'}
                </p>
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}
